<template>
  <div class="page">
    <div v-if="getModuleConfig('external_member_customer_bind.provider_error.step_section.enable_step_section')" class="p-3">
      <SharedStep :steps="getModuleConfig('thanks_page.step_section.steps')" />
    </div>

    <div v-if="getModuleConfig('external_member_customer_bind.provider_error.form_title')" class="page__title">
      {{ getModuleConfig("external_member_customer_bind.provider_error.form_title") }}
    </div>
    <div v-if="getModuleConfig('external_member_customer_bind.provider_error.form_desc')" class="page__desc">
      {{ getModuleConfig("external_member_customer_bind.provider_error.form_desc") }}
    </div>

    <div class="page__content" v-if="contentData" v-html="contentData"></div>

    <img
      v-for="image in contentImages"
      :src="image.image_url"
      :key="image.order"
      class="w-100"
    />

    <div class="page__button s-space-y-4">
      <MemberButton
        v-if="getModuleConfig('external_member_customer_bind.provider_error.button_text')"
        :button-text="getModuleConfig('external_member_customer_bind.provider_error.button_text')"
        :button-url="getModuleConfig('external_member_customer_bind.provider_error.button_url')"
        :type="getModuleConfig('external_member_customer_bind.provider_error.button_action')"
      ></MemberButton>
    </div>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import SharedStep from "@/components/Page/Liff/Shared/Steps";

export default {
  components: {
    SharedStep,
    MemberButton,
  },
  computed: {
    contentImages() {
      let contentImages = this.getModuleConfig("external_member_customer_bind.provider_error.content_images") || []
      contentImages.sort((a, b) => a.order - b.order)
      return contentImages
    },
    contentData() {
      return this.getModuleConfig("external_member_customer_bind.provider_error.content") ?? false;
    },
    showPage() {
      return this.getModuleConfig('external_member_customer_bind.provider_error.step_section.enable_step_section')
        || this.getModuleConfig('external_member_customer_bind.provider_error.form_title')
        || this.getModuleConfig('external_member_customer_bind.provider_error.form_desc')
    },
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('member_register', key);
    },
  },
};
</script>
